import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Delete")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    flat: "",
    "text-color": "primary",
    icon: "more_vert",
    size: "sm"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_menu, { "data-test": "edit-menu" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_list, { style: {"min-width":"70px"} }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                clickable: "",
                onClick: _ctx.onEdit
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"])), [
                [_directive_close_popup]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                disable: !_ctx.canDelete(),
                clickable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.canDelete() ? _ctx.onDelete() : ''))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disable"])), [
                [_directive_close_popup]
              ])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}